import StrapsService from "./StrapsService";
import DicesService from "./DicesService";
import CookieService from "./CookieService";

class ProductService {
  static strapId = "0010281186";

  static getCookieDices(diceIds, anagram) {
    let listOfDices = DicesService.getListOfDices();
    let dices = [];
    diceIds.forEach(diceId => {
      if (diceId === "anagram") {
        dices.push(anagram);
      } else {
        let dice = listOfDices.find(item => item.id === diceId)
        if (dice) dices.push(dice);
      }
    });
    return dices;
  }

  static getCookieStrap(strapId) {
    let strap = StrapsService.getStraps().find(item => item.id === strapId);
    this.strapId = strapId;
    return strap;
  }

  static getStrapId() {
    return this.strapId;
  }

  static getProduct() {
    const strapCookie = CookieService.getCookie("strap");
    const dicesCookie = CookieService.getCookie("dices");
    const strap = strapCookie
      ? this.getCookieStrap(strapCookie)
      : StrapsService.getStrap(0);
    const dices = dicesCookie
      ? this.getCookieDices(dicesCookie, strap.anagram)
      : [strap.anagram];
    const product = { strap: strap, dices: dices };
    return product;
  }
}

export default ProductService;
